/**
 * Category model
 */
export class Category {
  constructor(
    public id: number,
    public name: string,
    public slug: string,
    public description: string
  ) {}
}
